import { FunctionTypes } from '../../../components/ContributorSection/helpers';
import React from 'react';
import { PubSuffixTypeEnum } from '../../../types';
export var TabHeaders;
(function (TabHeaders) {
  TabHeaders["MAGAZINE"] = "Magazine";
  TabHeaders["NEWSPAPER"] = "Newspaper";
  TabHeaders["WEBSITE"] = "Website";
  TabHeaders["TV_RADIO"] = "TV/Radio";
})(TabHeaders || (TabHeaders = {}));
export var MethodRadioOption;
(function (MethodRadioOption) {
  MethodRadioOption["PERSONAL"] = "personal";
  MethodRadioOption["OTHER"] = "other";
})(MethodRadioOption || (MethodRadioOption = {}));
export var MediumRadioOption;
(function (MediumRadioOption) {
  MediumRadioOption["PHONE"] = "telephone";
  MediumRadioOption["MAIL"] = "e-mail";
  MediumRadioOption["ONLINE"] = "online";
  MediumRadioOption["PERSON"] = "";
})(MediumRadioOption || (MediumRadioOption = {}));
export var SourceRadioOption;
(function (SourceRadioOption) {
  SourceRadioOption["IN_PRINT"] = "";
  SourceRadioOption["DATA_BASE"] = "other";
})(SourceRadioOption || (SourceRadioOption = {}));
export var SourceOptions = [{
  key: PubSuffixTypeEnum.PUB_NONE,
  value: 'In print'
}, {
  key: PubSuffixTypeEnum.PUB_DATABASE,
  value: 'Published in an online database'
}];
export var MethodOptions = [{
  key: MethodRadioOption.PERSONAL,
  value: 'Personal interview (by you)'
}, {
  key: MethodRadioOption.OTHER,
  value: 'Other'
}];
export var MediumOptions = [{
  key: MediumRadioOption.PHONE,
  value: 'By phone'
}, {
  key: MediumRadioOption.MAIL,
  value: 'E-mail'
}, {
  key: MediumRadioOption.ONLINE,
  value: 'Web'
}, {
  key: MediumRadioOption.PERSON,
  value: 'In person'
}];
export var CitingTranscriptOptions = [{
  key: 'no',
  value: 'Actual interview'
}, {
  key: 'yes',
  value: 'A transcript'
}];
export var InterviewntroductionOptions;
(function (InterviewntroductionOptions) {
  InterviewntroductionOptions["SectionInterviewer"] = "Interviewer";
  InterviewntroductionOptions["SectionInterviewee"] = "Interviewee";
})(InterviewntroductionOptions || (InterviewntroductionOptions = {}));
export var InterviewRoleOptions = [{
  uuid: FunctionTypes.INTERVIEWER,
  value: FunctionTypes.INTERVIEWER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, InterviewntroductionOptions.SectionInterviewer)
}, {
  uuid: FunctionTypes.INTERVIEWEE,
  value: FunctionTypes.INTERVIEWEE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, InterviewntroductionOptions.SectionInterviewee)
}];
/** radio group options title and testIds */
export var METHOD_RADIO_INPUT_LABEL = 'Method';
export var METHOD_RADIO_INPUT_TEST_ID = 'method-radio-input-test-id';
export var MEDIUM_RADIO_INPUT_LABEL = 'Medium';
export var MEDIUM_RADIO_INPUT_TEST_ID = 'medium-radio-input-test-id';
export var CITING_RADIO_INPUT_LABEL = 'Citing';
export var CITING_RADIO_INPUT_TEST_ID = 'citing-radio-input-test-id';
export var INTERVIEW_TITLE_INPUT_LABEL = 'Interview title';
export var INTERVIEW_TITLE_INPUT_TEST_ID = 'interview-title';
export var SOURCE_RADIO_INPUT_LABEL = 'Source was';
export var SOURCE_RADIO_INPUT_TEST_ID = 'source-was-radio-input-test-id';
export var INTERVIEWED_DATE_KEY = 'date-interview-pub-date';
export var INTERVIEWED_DATE_LABEL = 'Date interviewed';
export var INTERVIEWED_DATE_TEST_ID = 'date-interview-pub-date-test-id';
export var INTERVIEWED_DATE_FIELD_NAME = ['interview.day', 'interview.month', 'interview.year'];